<ng-container *ngIf="modalConfig.footer; else defaultFooterButtons">
  <ng-container *nzStringTemplateOutlet="modalConfig.footer; context: { $implicit: modalConfig.modalComponentParams, modalRef: modalRef }">
    <div *ngIf="!buttonsFooter" [innerHTML]="modalConfig.footer"></div>
    <ng-container *ngIf="buttonsFooter">
      <button
        *ngFor="let button of buttons"
        ui-button
        (click)="onButtonClick(button)"
        [hidden]="!getButtonCallableProp(button, 'show')"
        [buttonLoading]="getButtonCallableProp(button, 'loading')"
        [disabled]="getButtonCallableProp(button, 'disabled')"
        [buttonType]="button.type!"
        [buttonDanger]="button.danger"
        [buttonShape]="button.shape!"
        [buttonSize]="button.size!"
        [buttonGhost]="button.ghost!">
        {{ button.label }}
      </button>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #defaultFooterButtons>
  <button
    *ngIf="modalConfig.modalCancelText !== null"
    [attr.cdkFocusInitial]="modalConfig.modalAutofocus === 'cancel' || null"
    ui-button
    (click)="onCancel()"
    [buttonLoading]="!!modalConfig.modalCancelLoading"
    [disabled]="modalConfig.modalCancelDisabled">
    {{ modalConfig.modalCancelText || locale.cancelText }}
  </button>
  <button
    *ngIf="modalConfig.modalOkText !== null"
    [attr.cdkFocusInitial]="modalConfig.modalAutofocus === 'ok' || null"
    ui-button
    [buttonType]="modalConfig.modalOkType!"
    [buttonDanger]="modalConfig.modalOkDanger"
    (click)="onOk()"
    [buttonLoading]="!!modalConfig.modalOkLoading"
    [disabled]="modalConfig.modalOkDisabled">
    {{ modalConfig.modalOkText || locale.okText }}
  </button>
</ng-template>
